import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { Box, Paper } from "@material-ui/core";
import Select from "react-select";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  overflow: {
    height: "calc(100% - 220px)",
    width: "350px",
    overflowY: "scroll",
    overflowX: "hidden",
    top: "127px",
    left: "0",
    position: "absolute",
    borderRadius: 0,
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 100px)'
    }
  },
  overFlow2: {
    height: "calc(100% - 65px)",
    width: "350px",
    // overflowX: "hidden",
    top: "150px",
    right: "40px",
    position: "absolute",
    borderRadius: 0,
    [theme.breakpoints.down("md")]: {
      top: "1260px",
      width: "calc(100vw - 100px)",
      height: "500px",
      left: "5px",
    },
  },
  root: {
    width: "350px",
    backgroundColor: theme.palette.background.paper,
    position: "static",
    height: "100%",
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 100px)'
    }
  },
  inline: {
    display: "inline",
  },
  objectFit: {
    objectFit: "contain",
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
    fontWeight: "normal",
    // position: 'absolute !important',
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
  },
  unreadBox: {
    height: "30px",
    width: "30px",
    borderRadius: "50%",
    backgroundColor: "#b499c7",
    color: "white",
    fontSize: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    right: "25px",
    top: "50%",
    transform: "translateY(-50%)",
  },
}));

export default function AlignItemsList(props) {
  const classes = useStyles();
  const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const removeFirstItem = (arr, label) => {
    let newArr = arr?.filter((item, index) => true);
    newArr?.unshift({ value: "", label: label });
    return newArr;
  };

  return (
    <div className={classes.overFlow2}>
      <ListItem
        alignItems="center"
        style={{
          width: "100%",
          backgroundColor: "#6f59a6",
          color: "white",
          fontFamily: "Montserrat",
          fontWeight: "bold",
          position: "absolute",
          top: 0,
          left: 0,
          height: "71px",
        }}
      >
        <ListItemText
          primary={
            <>
              <Typography
                style={{
                  fontSize: "1rem",
                  fontFamily: "Montserrat",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                Start New Conversation
              </Typography>
            </>
          }
          secondary={
            <>
              <Typography
                style={{
                  fontSize: "12px",
                  fontFamily: "Montserrat",
                  color: "white",
                }}
              >
                TOTAL MENTORS: {props.newMenu?.length}
              </Typography>
            </>
          }
        />
      </ListItem>
      <ListItem
        alignItems="center"
        style={{
          width: "100%",
          backgroundColor: "#6f59a6",
          color: "white",
          fontFamily: "Montserrat",
          fontWeight: "bold",
          position: "absolute",
          top: 70,
          left: 0,
          zIndex: 100,
        }}
      >
        <Select
          className={classes.select}
          placeholder="Search"
          options={removeFirstItem(
            props?.newMenu?.map((item) => ({
              value: item.id,
              label: item.mentorRequest?.mentorName,
            })),
            "Select Mentor"
          )}
          onChange={(selected) => {
            props.setNewChatMode(true);
            const requiredObj = props.newMenu?.find(
              (item) => item.id === selected.value
            );
            props.setActiveChat({
              apartyId: value?.id,
              bpartyId: requiredObj?.mentorId,
              bpartyImage: requiredObj?.mentorRequest?.mentorProfilePic,
              bpartyName: requiredObj?.mentorRequest?.mentorName,
            });
            props.setChatData(null);
          }}
          styles={{
            menu: (styles) => {
              return {
                ...styles,
                width: "auto",
                zIndex: 1000,
              };
            },
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
              return {
                ...styles,
                backgroundColor: isSelected
                  ? "#b499c7"
                  : isFocused
                  ? "#e4d7ee"
                  : "white",
                color: isSelected ? "white" : "black",
                cursor: isDisabled ? "not-allowed" : "default",
              };
            },
          }}
        />
      </ListItem>
      <Paper className={classes.overflow}>
        <List className={classes.root}>
          {props.newMenu?.map((datum) => (
            <>
              <ListItem
                button
                onClick={() => {
                  const value = JSON.parse(
                    localStorage.getItem("SavedLoggedInData")
                  );
                  props.setNewChatMode(true);
                  props.setActiveChat({
                    apartyId: value?.id,
                    bpartyId: datum?.mentorId,
                    bpartyImage: datum?.mentorRequest?.mentorProfilePic,
                    bpartyName: datum?.mentorRequest?.mentorName,
                  });
                  props.setChatData(null);
                }}
                alignItems="center"
              >
                <ListItemAvatar>
                  <Avatar
                    classes={{
                      img: classes.objectFit,
                    }}
                    src={datum?.mentorRequest?.mentorProfilePic}
                  />
                </ListItemAvatar>
                 <ListItemText primary={datum?.mentorRequest?.mentorName} />
              
              </ListItem>
              <Divider variant="inset" component="li" />
            </>
          ))}
        </List>
      </Paper>
    </div>
  );
}
